import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import { SectionTitle, ConnectathonCardFlip } from "src/library/components/exports";
import CONTENT from "src/library/content.json";
import { Partner, PartnersSectionProps } from "src/library/types/types";

export default function Partners(props: PartnersSectionProps) {
  const { sectionBackGroundColor } = props;
  const {
    partners: { title, partnerList },
  } = CONTENT;

  return (
    <Box
      sx={{
        pt: 2,
        pb: 6,
      }}
    >
      <Container maxWidth="lg">
        <SectionTitle title={title} />
        <Grid container justifyContent="center" spacing={2} sx={{ mt: 3 }}>
          {partnerList.map((partner: Partner) => (
            <Grid
              item
              key={partner.name}
              xs={12}
              sm={6}
              md={4}
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="400"
              data-aos-easing="ease-in-out"
              sx={{ minWidth: "320px" }}
            >
              <ConnectathonCardFlip
                partner={partner}
                sectionBackGroundColor={sectionBackGroundColor}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
